// components/SolutionsSection/SolutionsSection.jsx
import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { API_BASE } from '../config/api';
import './css/SolutionsSection.css';

const SolutionsSection = () => {
  const defaultSolutions = useMemo(
    () => ({
      subtitle_text: 'مشكلتك، ولها حل',
      main_heading: 'ماذا تستفيدين من العمل معي؟',
      card1_title: 'فهم الثغرات',
      card1_desc:
        'أفهم مشكلة بحثك عن قرب، وأحدد لك الثغرات بدقة متناهية لتتجاوزي مرحلة الضياع.',
      card2_title: 'التوجيه الواضح',
      card2_desc:
        'أقدم لك توجيهًا أكاديميًا منهجيًا بدلاً من التخبط العشوائي، لتعرفي طريقك بوضوح.',
      card3_title: 'بناء الثقة',
      card3_desc:
        'لا نكتفي بإنهاء البحث، بل نبني لك ثقة أكاديمية قوية بنفسك وبما كتبتِه.',
      cta_text: 'تعرفي على خدماتي',
    }),
    []
  );

  const [solutions, setSolutions] = useState(defaultSolutions);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API_BASE}/api/solutions`)
      .then((res) => {
        const db = res.data?.solutions;
        if (!mounted) return;
        setSolutions(db ? { ...defaultSolutions, ...db } : defaultSolutions);
      })
      .catch((err) => {
        console.error('Failed to load solutions:', err);
        if (!mounted) return;
        setSolutions(defaultSolutions);
      });

    return () => {
      mounted = false;
    };
  }, [defaultSolutions]);

  const cards = useMemo(
    () => [
      { title: solutions.card1_title, desc: solutions.card1_desc, delay: 0.1 },
      { title: solutions.card2_title, desc: solutions.card2_desc, delay: 0.3 },
      { title: solutions.card3_title, desc: solutions.card3_desc, delay: 0.5 },
    ],
    [
      solutions.card1_title,
      solutions.card1_desc,
      solutions.card2_title,
      solutions.card2_desc,
      solutions.card3_title,
      solutions.card3_desc,
    ]
  );
  return (
    <section className="solutions-section" dir="rtl">
      <div className="container">
        <div className="text-center mb-5">
          <h6 className="sub-heading">{solutions.subtitle_text}</h6>
          <h2 className="main-heading">{solutions.main_heading}</h2>
        </div>

        <div className="row g-4 justify-content-center">
          {cards.map((card, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <motion.div 
                className="solution-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: card.delay }}
              >
                <div className="circle-bg"></div>
                <h3 className="card-script-title">{card.title}</h3>
                <p className="card-desc">{card.desc}</p>
              </motion.div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-5">
           <Link to="/services" className="btn-outline-dark">{solutions.cta_text}</Link>
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;